<template>
  <div
    class="exercises-activities"
    :class="mouseDown ? 'dragging' : ''"
    @mouseleave="mouseDown = false"
    @mouseup="mouseDown = false"
  >
    <div class="exercises-folders" v-if="!readonly || hasImportsFolders">
      <h5>Folders</h5>
      <v-btn
        rounded
        class="mr-2 mb-2 new"
        :color="!queryParams.folderId ? 'accent' : ''"
        elevation="0"
        :class="mouseDown ? 'dragging' : ''"
        @click="filterFolder(null)"
        @mouseup="folderMouseUp(null)"
        @dragenter.native="$event.preventDefault()"
        @dragover.native="allowDrop"
        @dragleave.native="leaveDropZone"
        @drop.native="
          leaveDropZone($event)
          folderMouseUp(null)
        "
      >
        Main
      </v-btn>
      <div
        class="exercises-folders--folder mr-2 pr-2 mb-2"
        :class="hasImportsFolders ? 'exercises-folders--imported' : ''"
        v-for="folder in sortedFolders"
        :key="'folder-' + folder.id"
      >
        <v-btn
          rounded
          elevation="0"
          :class="mouseDown ? 'dragging' : ''"
          :color="folder.id == queryParams.folderId ? 'accent' : 'bhWhite'"
          @click="filterFolder(folder.id)"
          @mouseup="folderMouseUp(folder.id)"
          @dragenter.native="$event.preventDefault()"
          @dragover.native="allowDrop"
          @dragleave.native="leaveDropZone"
          @drop.native="
            leaveDropZone($event)
            folderMouseUp(folder.id)
          "
        >
          {{ folder.title }}
        </v-btn>
        <v-btn
          v-if="hasImportsFolders"
          icon
          small
          elevation="0"
          class="exercises-folders__icon"
          :class="
            folder.owned
              ? 'exercises-folders__icon--owned'
              : folder.partiallyOwned
              ? 'exercises-folders__icon--partially-owned'
              : ''
          "
          ><v-icon>bhi-copy</v-icon></v-btn
        >
        <v-btn
          v-if="showMoreMenuBtn[folder.id]"
          icon
          elevation="0"
          @click.stop="openMenu($event, folder.id)"
          x-small
          class="exercises-folders__more"
        >
          <v-icon>bhi-dots-vertical</v-icon>
        </v-btn>
        <v-menu
          v-if="!hasImportsFolders"
          rounded
          absolute
          offset-x
          transition="false"
          v-model="showMenu[folder.id]"
          :position-x="x"
          :position-y="y"
        >
          <v-list class="library-folder__more--menu">
            <v-list-item
              v-if="folder && !folder.locked"
              link
              dense
              @click="$emit('rename-folder', folder.id, folder.title)"
            >
              <v-list-item-icon>
                <v-icon>bhi-pencil</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Rename
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="folder && !folder.locked"
              link
              dense
              @click="$emit('duplicate-folder', folder.id)"
            >
              <v-list-item-icon>
                <v-icon>bhi-copy</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Duplicate
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="isAdmin"
              link
              dense
              @click="$emit('share-folder-items', folder.id)"
            >
              <v-list-item-icon>
                <v-icon>bhi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Share
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="folder && !folder.locked"
              link
              dense
              @click="removeFolder(folder)"
            >
              <v-list-item-icon>
                <v-icon>bhi-trash</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Remove
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          v-else
          rounded
          absolute
          offset-x
          transition="false"
          v-model="showMenu[folder.id]"
          :position-x="x"
          :position-y="y"
        >
          <v-list class="library-folder__more--menu">
            <v-list-item link dense @click="importFolder(folder)">
              <v-list-item-icon>
                <v-icon>bhi-copy</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Import
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div v-if="!hasImportsFolders">
        <v-btn
          v-if="exerciseFolders.length > 0"
          class="exercises-folders--folder__add"
          rounded
          text
          icon
          small
          @click="$emit('new-folder')"
        >
          <v-icon size="12">bhi-plus</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="exercises-folders--folder__new"
          rounded
          text
          color="bhGray"
          @click="$emit('new-folder')"
        >
          <v-icon size="12">bhi-plus</v-icon> Create new folder
        </v-btn>
      </div>
    </div>
    <h5 class="exercises-heading">Activities</h5>
    <div class="exercises-exercises__wrapper">
      <div
        class="exercises-tile bordered create"
        v-if="!queryParams.q && !readonly && showCreateSeriesButton"
      >
        <v-btn
          elevation="0"
          rounded
          color="accent"
          @click="$emit('create-new', 'SERIES', true)"
        >
          Create new Circuit
        </v-btn>
      </div>
      <VueSelecto
        v-if="massSelect"
        :container="'document.body'"
        :dragContainer="'.exercises-exercises__wrapper'"
        :selectableTargets="['.exercise-tile']"
        :selectByClick="false"
        :selectFromInside="false"
        :continueSelect="false"
        :toggleContinueSelect="'shift'"
        :hitRate="0"
        @select="onSelect"
      />
      <exercise-tile
        v-for="exercise in exerciseDefinitions"
        :draggable="exercise.selected"
        :key="'exercise-' + exercise.type + '-' + exercise.id"
        :type="exercise.type"
        :calendar-id="exercise.id"
        :id="
          exercise.type == 'EXERCISE'
            ? exercise.exercise.id
            : exercise.type == 'SERIES'
            ? exercise.series.id
            : exercise.activity.id
        "
        :title="
          exercise.type == 'EXERCISE'
            ? exercise.exercise.title
            : exercise.type == 'SERIES'
            ? exercise.series.title
            : exercise.activity.title
        "
        :description="
          exercise.type == 'EXERCISE'
            ? exercise.exercise.description
            : exercise.type == 'SERIES'
            ? ''
            : exercise.activity.description
        "
        :additional-media="
          exercise.type == 'EXERCISE'
            ? exercise.exercise.additionalMedia
            : exercise.type == 'SERIES'
            ? exercise.series.additionalMedia
            : exercise.activity.additionalMedia
        "
        :media="
          exercise.type == 'EXERCISE'
            ? exercise.exercise.media
            : exercise.type == 'SERIES'
            ? exercise.series.media
            : exercise.activity.media
        "
        :mobileStaticMedia="
          exercise.type == 'EXERCISE'
            ? exercise.exercise.mobileStaticMedia
            : exercise.type == 'SERIES'
            ? exercise.series.mobileStaticMedia
            : exercise.activity.mobileStaticMedia
        "
        :multi-thumbnail="
          exercise.type == 'SERIES' ? exercise.series.exerciseDefinitions : null
        "
        :editable="true"
        :getResourceById="getResourceById"
        :hoverLoader="
          progressBarsValues[
            exercise.type +
              '__' +
              (exercise.type == 'EXERCISE'
                ? exercise.exercise.id
                : exercise.type == 'ACTIVITY'
                ? exercise.activity.id
                : exercise.series.id)
          ]
        "
        :readonly="readonly"
        :collection-is-owned="exercise.owned"
        :collection-mode="collectionMode"
        :time="exercise.type == 'ACTIVITY' ? exercise.activity.time : false"
        :sharable="sharable"
        :sharable-to-administration="sharableToAdministration"
        :movable="movable"
        :duplicable="true"
        @mouseover="exerciseOpenHover(exercise)"
        @mouseleave="exerciseClearHover(exercise)"
        @stopHoverPopup="
          exerciseClearHover(
            exercise.type == 'EXERCISE' ? exercise.exercise.id : null,
          )
          exerciseCloseHover()
        "
        @delete="openDeleteExerciseDialog(exercise)"
        @move-exercise="$emit('move-exercises', [exercise.id], $event)"
        @edit="openEditExerciseDialog(exercise)"
        @share="openShareExerciseDialog(exercise)"
        @share-back="openShareExerciseBackDialog(exercise)"
        @import="exerciseImport(exercise, exercise.type)"
        @mousedown.native="mouseDown = true"
        @mouseup.native="mouseDown = false"
        @dragstart.native="exerciseClearHover(exercise)"
        @duplicate="duplicateItems(exercise.id)"
      />
    </div>
    <v-pagination
      v-if="pagination && pagination.pageCount > 1"
      circle
      :length="pagination.pageCount"
      :value="pagination.page + 1"
      class="exercises-pagination"
      @input="$emit('pagination-change', $event)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ExerciseTile from '@/components/exercises/ExerciseTile.vue'
import VueSelecto from 'vue-selecto'

export default {
  name: 'ExercisesActivities',
  components: {
    ExerciseTile,
    VueSelecto,
  },
  props: {
    exerciseDefinitions: {
      type: Array,
      default: () => [],
    },
    exerciseFolders: {
      type: Array,
      default: () => [],
    },
    getResourceById: {
      type: Function,
      default: () => null,
    },
    queryParams: {
      type: Object,
      default: () => {},
    },
    progressBarsValues: {
      type: Object,
      default: () => {},
    },
    advancedSearchActive: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    collectionMode: {
      type: Boolean,
      default: false,
    },
    massSelect: {
      type: Boolean,
      default: false,
    },
    sharable: {
      type: Boolean,
      default: false,
    },
    sharableToAdministration: {
      type: Boolean,
      default: false,
    },
    movable: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: [Boolean, Object],
      default: false,
    },
    showCreateSeriesButton: {
      type: Boolean,
      default: false,
    },
    hasImportsFolders: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mouseDown: false,
      selectedExercises: [],
      showMenu: [],
      x: 0,
      y: 0,
      fab: false,
    }
  },
  computed: {
    sortedFolders() {
      const folders = [...this.exerciseFolders]
      return this.exerciseFolders?.length > 0
        ? folders.sort((a, b) => a.title.localeCompare(b.title))
        : []
    },
    showMoreMenuBtn() {
      let showMoreMenuBtn = {}
      for (const folder of this.sortedFolders) {
        const val = !(folder.locked && !this.isAdmin)
        showMoreMenuBtn[folder.id] = val
      }
      return showMoreMenuBtn
    },
  },
  created() {},
  methods: {
    ...mapActions('exercisesStates', ['duplicateRoutinesDefinitionsItems']),
    removeFolder(folder) {
      if (!folder?.locked) {
        this.$emit('remove-folder', folder.id, 'exercises')
      }
    },
    importFolder(folder) {
      if (!folder?.locked && this.hasImportsFolders) {
        this.$emit('import-folder', folder.id)
      }
    },
    openDeleteExerciseDialog(exercise) {
      this.$emit(
        'delete-dialog',
        exercise.type == 'EXERCISE'
          ? exercise.exercise.id
          : exercise.type == 'ACTIVITY'
          ? exercise.activity.id
          : exercise.series.id,
        exercise.type,
        'exercises',
      )
    },
    openEditExerciseDialog(exercise) {
      this.$emit(
        'edit-dialog',
        exercise.type == 'EXERCISE'
          ? exercise.exercise.id
          : exercise.type == 'ACTIVITY'
          ? exercise.activity.id
          : exercise.series.id,
        exercise.type,
      )
    },
    openShareExerciseDialog(exercise) {
      if (this.selectedExercises.length == 0)
        this.$emit(
          'share-dialog',
          exercise.type == 'EXERCISE'
            ? exercise.exercise.id
            : exercise.type == 'ACTIVITY'
            ? exercise.activity.id
            : exercise.series.id,
          exercise.type,
        )
      else this.$emit('share-multiple-dialog', this.selectedExercises)
    },
    openShareExerciseBackDialog(exercise) {
      this.$emit(
        'share-back-dialog',
        exercise.type == 'EXERCISE'
          ? exercise.exercise.id
          : exercise.type == 'ACTIVITY'
          ? exercise.activity.id
          : exercise.series.id,
        exercise.type,
      )
    },
    exerciseOpenHover(exercise) {
      const id =
        exercise.type == 'EXERCISE'
          ? exercise.exercise.id
          : exercise.type == 'ACTIVITY'
          ? exercise.activity.id
          : exercise.series.id
      const media =
        exercise.type == 'EXERCISE'
          ? exercise.exercise.media
          : exercise.type == 'ACTIVITY'
          ? exercise.activity.media
          : exercise.series.media
      const mobileStaticMedia =
        exercise.type == 'EXERCISE'
          ? exercise.exercise.mobileStaticMedia
          : exercise.type == 'ACTIVITY'
          ? exercise.activity.mobileStaticMedia
          : exercise.series.mobileStaticMedia
      const additionalMedia =
        exercise.type == 'EXERCISE'
          ? exercise.exercise.additionalMedia
          : exercise.type == 'ACTIVITY'
          ? exercise.activity.additionalMedia
          : exercise.series.additionalMedia
      this.$emit(
        'open-hover',
        exercise.type + '__' + id,
        media,
        mobileStaticMedia,
        additionalMedia,
      )
    },
    exerciseClearHover(exercise) {
      this.$emit(
        'clear-hover',
        exercise.type +
          '__' +
          (exercise.type == 'EXERCISE'
            ? exercise.exercise.id
            : exercise.type == 'ACTIVITY'
            ? exercise.activity.id
            : exercise.series.id),
      )
    },
    exerciseCloseHover() {
      this.$emit('close-hover')
    },
    exerciseImport(exercise, type) {
      this.$emit('import', { exerciseId: exercise.id })
    },
    filterFolder(value) {
      const key = 'folderId'
      this.$emit('search-on:input', { key, value })
    },
    onSelect(e) {
      e.added.forEach(el => {
        if (
          this.selectedExercises.findIndex(
            el2 => el2.id == el.attributes['data-id'].nodeValue,
          ) == -1
        )
          this.selectedExercises.push({
            id: el.attributes['data-id'].nodeValue,
            type: el.attributes['data-type'].nodeValue,
            typeId: el.attributes['data-type-id'].nodeValue,
          })
        let item = this.exerciseDefinitions.find(item => {
          if (item.id == el.attributes['data-id'].nodeValue) return item
        })
        if (item) item.selected = true
        el.classList.add('selected')
      })
      e.removed.forEach(el => {
        let ind = this.selectedExercises.findIndex(
          el2 => el2.id == el.attributes['data-id'].nodeValue,
        )
        let item = this.exerciseDefinitions.find(item => {
          if (item.id == el.attributes['data-id'].nodeValue) return item
        })
        if (item) item.selected = false
        if (ind > -1) this.selectedExercises.splice(ind, 1)
        el.classList.remove('selected')
      })
      if (this.hasImportsFolders) {
        this.$emit('selected-exercises', this.selectedExercises)
      }
    },
    folderMouseUp(folderId) {
      if (this.mouseDown && this.selectedExercises.length > 0) {
        this.$emit('move-exercises', this.selectedExercises, folderId)
        this.selectedExercises = []
      }
      this.mouseDown = false
    },
    openMenu(e, id) {
      e.stopPropagation()
      this.x = e.clientX
      this.y = e.clientY
      this.$emit('changeMenuType', 'more')
      this.$nextTick(() => {
        this.showMenu = []
        this.showMenu[id] = true
      })
    },
    openExercisePreviewDialog(exercise) {
      this.exerciseClearHover(exercise)
      this.$emit('get-exercise-preview', {
        id:
          exercise.type == 'EXERCISE'
            ? exercise.exercise.id
            : exercise.type == 'SERIES'
            ? exercise.series.id
            : exercise.activity.id,
        type: exercise.type,
      })
    },
    allowDrop(e) {
      e.target.classList.add('drop-active')
      e.preventDefault()
    },
    leaveDropZone(e) {
      e.target.classList.remove('drop-active')
    },
    duplicateItems(id) {
      const itemIds = []

      if (this.selectedExercises.length > 0) {
        this.selectedExercises.forEach(item => {
          itemIds.push(Number(item.id))
        })
      } else {
        itemIds.push(id)
      }
      this.duplicateRoutinesDefinitionsItems(itemIds)
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.exercises-folders {
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .v-btn {
    &.new {
      width: 268px;
    }
  }
  h5 {
    color: $bh-gray;
    font-size: 14px;
    margin-right: 8px;
    width: 100%;
  }
  &--folder__new {
    background-color: $bh-white;
    color: $bh-gray !important;
    margin-bottom: 8px;
    .v-icon {
      margin-right: 4px;
      margin-bottom: 2px;
    }
  }
  &--folder__add {
    margin-bottom: 8px;
    max-width: 32px;
  }
  &__icon {
    &--owned {
      background: $bh-green;
      .v-icon {
        color: $bh-white !important;
      }
    }
    &--partially-owned {
      background: $bh-yellow;
      .v-icon {
        color: $bh-white !important;
      }
    }
  }

  &--imported {
    position: relative;
    display: inline-block;
    background: var(--bh-white);
    border-radius: 64px;
    .v-btn {
      &:first-child {
        width: 240px;
      }
      &__content {
        max-width: 210px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
      }
    }
    .exercises-folders__more {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0;
      pointer-events: none;
    }
    &:hover {
      .exercises-folders__icon {
        opacity: 0;
      }
      .exercises-folders__more {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
}
.exercises-pagination {
  min-height: 100px;

  .v-pagination__item {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.exercises-tile.create {
  width: 280px;
  border: 1px solid $bh-white;
  border-radius: 16px;
  padding: $gutter/2;
  display: flex;
  align-items: center;
  margin: 8px;
  background: $bh-white;
  position: relative;
  .v-speed-dial__list {
    .v-btn {
      color: $bh-white;
      .v-icon {
        margin-right: 4px;
      }
    }
  }
  &.bordered {
    border-color: transparent;
    background: transparent;
  }
  .v-btn {
  }
  h5 {
    color: $bh-black;
  }
}
</style>
